<template>
  <div id="app">
    <naveco />
    <!-- <left-nav></left-nav> -->
  </div>
</template>

<script>
import naveco from "./components/index.vue";

export default {
  name: "App",
  components: {
    naveco,
    // leftNav
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue